import {Component, OnInit, TemplateRef} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {APIHelper} from "../../../apihelper";
import {SharedResources} from "../../../shared-resources";
import {Orders} from "../../../models/orders";
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup} from "@angular/forms";
import {DeviceDetectorService} from "ngx-device-detector";

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit {


  constructor(private http: HttpClient, private modalService: NgbModal, private deviceService: DeviceDetectorService) {
  }

  intervalReceptie: FormGroup = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });

  hrefReport: string = '';
  orders: Orders[] = [];
  numberOfOrderPages: number = 0;
  currentOrderPage: number = 1;
  currentOrderSortColumn: string = '';
  currentOrderSortDesc: boolean = false;
  currentOrderSearchWord: string = '';
  currentOrderDateStart: Date = new Date(2000, 1, 1);
  currentOrderDateEnd: Date = new Date(2030, 12, 31);
  currentOrderStates: string = '';
  stari = new FormControl();
  listaStari: any[] = [['CONFIRMATĂ', 'Confirmată'], ['ÎN LUCRU', 'În lucru'], ['FINALIZATĂ','Finalizată'], ['ANULATĂ','Anulată']];
  isMobile: boolean = false;
  hrefReportPO: string = '';

  refreshDisplay() : void {
    if (this.isMobile) {
      this.currentOrderStates = 'ÎN LUCRU';
    }
    this.http.get<any>(`${APIHelper.APIUrl}order?OrderBy=${this.currentOrderSortColumn}&Desc=${this.currentOrderSortDesc}&Search=${encodeURIComponent(this.currentOrderSearchWord)}&Page=${this.currentOrderPage}&DateStart=${this.currentOrderDateStart.toISOString().slice(0, 10)}&DateEnd=${this.currentOrderDateEnd.toISOString().slice(0, 10)}&Stare=${this.currentOrderStates}`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        })
      }).subscribe(
      (response: any) => {
        if (response.total > 0) {
          if (Math.floor((response.total / 5)) + (response.total % 5 != 0 ? 1 : 0) < this.currentOrderPage) {
            this.currentOrderPage = 1;
            this.http.get<any>(`${APIHelper.APIUrl}order?OrderBy=${this.currentOrderSortColumn}&Desc=${this.currentOrderSortDesc}&Search=${encodeURIComponent(this.currentOrderSearchWord)}&Page=${this.currentOrderPage}&DateStart=${this.currentOrderDateStart.toISOString().slice(0, 10)}&DateEnd=${this.currentOrderDateEnd.toISOString().slice(0, 10)}&Stare=${this.currentOrderStates}`,
              {
                headers: new HttpHeaders({
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${localStorage.getItem('token')}`
                })
              }).subscribe(
              (response: any) => {
                this.orders = response.content;
                this.numberOfOrderPages = Math.floor((response.total / 5)) + (response.total % 5 != 0 ? 1 : 0);
                SharedResources._isLoadingBS.next(false);
              }, (error: any) => {
                alert(error.error);
                SharedResources._isLoadingBS.next(false);
              }
            );
          } else {
            this.orders = response.content;
            this.numberOfOrderPages = Math.floor((response.total / 5)) + (response.total % 5 != 0 ? 1 : 0);
            SharedResources._isLoadingBS.next(false);
          }
        } else {
          this.orders = [];
          this.numberOfOrderPages = 0;
        }
        SharedResources._isLoadingBS.next(false);
      }, (error: any) => {
        alert(error.error);
        SharedResources._isLoadingBS.next(false);
      });
  }

  ngOnInit(): void {
    this.hrefReport = APIHelper.APIUrl + "report?OrderId="
    this.hrefReportPO = APIHelper.APIUrl + "reportpo?PO="
    this.isMobile = this.deviceService.isMobile();
    SharedResources._isLoadingBS.next(true);
    this.currentOrderPage = SharedResources.currentOrderPage;
    this.currentOrderSortColumn = SharedResources.currentOrderSortColumn;
    this.currentOrderSortDesc = SharedResources.currentOrderSortDesc;
    this.currentOrderSearchWord = SharedResources.currentOrderSearchWord;
    this.currentOrderDateStart = SharedResources.currentOrderDateStart;
    this.currentOrderDateEnd = SharedResources.currentOrderDateEnd;
    this.currentOrderStates = SharedResources.currentOrderStates;
    this.refreshDisplay();
  }

  editOrder(order: Orders) {
    SharedResources.currentEditOrder = order;
    SharedResources.currentScreen = 'editOrder';
    SharedResources._currentScreenBS.next('editOrder');
  }

  smallFont(isMobile : any) {
    if (isMobile) {
      return {
        'font-size': 'small'
      }
    } else {
      return {};
    }
  }

  deleteOrder(order: Orders) {
    if (confirm(`Sunteți sigur(ă) că vreți să ștergeți comanda cu PO-ul ${order.PO} și numărul de factură ${order.NumarFactura}?`)) {
      SharedResources._isLoadingBS.next(true);
      this.http.delete<any>(
        `${APIHelper.APIUrl}order?Id=${order.Id}`,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem('token')}`
          })
        }).subscribe(
        (response: any) => {
          this.refreshDisplay();
          SharedResources._isLoadingBS.next(false);
        }, (error: any) => {
          alert(error.error);
          SharedResources._isLoadingBS.next(false);
        }
      )
    }
  }

  changeScreenToInputOrder() {
    SharedResources.currentScreen = 'inputOrder';
    SharedResources._currentScreenBS.next('inputOrder');
  }

  refreshAfterSearch(searchWord: string) {
    SharedResources.currentOrderSearchWord = searchWord;
    this.currentOrderSearchWord = searchWord;
    this.refreshDisplay();
  }

  changeSortOnPO() {
    if (this.currentOrderSortColumn == 'PO') {
      SharedResources.currentOrderSortDesc = !SharedResources.currentOrderSortDesc;
      this.currentOrderSortDesc = !this.currentOrderSortDesc;
    } else {
      SharedResources.currentOrderSortColumn = 'PO';
      this.currentOrderSortColumn = 'PO';
      SharedResources.currentOrderSortDesc = false;
      this.currentOrderSortDesc = false;
    }
    this.refreshDisplay();
  }

  changeSortOnConditieLivrare() {
    if (this.currentOrderSortColumn == 'CONDITIELIVRARE') {
      SharedResources.currentOrderSortDesc = !SharedResources.currentOrderSortDesc;
      this.currentOrderSortDesc = !this.currentOrderSortDesc;
    } else {
      SharedResources.currentOrderSortColumn = 'CONDITIELIVRARE';
      this.currentOrderSortColumn = 'CONDITIELIVRARE';
      SharedResources.currentOrderSortDesc = false;
      this.currentOrderSortDesc = false;
    }
    this.refreshDisplay();
  }

  changeSortOnNumarFactura() {
    if (this.currentOrderSortColumn == 'NUMARFACTURA') {
      SharedResources.currentOrderSortDesc = !SharedResources.currentOrderSortDesc;
      this.currentOrderSortDesc = !this.currentOrderSortDesc;
    } else {
      SharedResources.currentOrderSortColumn = 'NUMARFACTURA';
      this.currentOrderSortColumn = 'NUMARFACTURA';
      SharedResources.currentOrderSortDesc = false;
      this.currentOrderSortDesc = false;
    }
    this.refreshDisplay();
  }

  changeSortOnDataReceptie() {
    if (this.currentOrderSortColumn == 'DATARECEPTIE') {
      SharedResources.currentOrderSortDesc = !SharedResources.currentOrderSortDesc;
      this.currentOrderSortDesc = !this.currentOrderSortDesc;
    } else {
      SharedResources.currentOrderSortColumn = 'DATARECEPTIE';
      this.currentOrderSortColumn = 'DATARECEPTIE';
      SharedResources.currentOrderSortDesc = false;
      this.currentOrderSortDesc = false;
    }
    this.refreshDisplay();
  }

  goToFirstPage() {
    SharedResources.currentOrderPage = 1;
    this.currentOrderPage = 1;
    this.refreshDisplay();
  }

  goToPrevPage() {
    if (this.currentOrderPage == 1) {
      this.goToLastPage()
    } else {
      SharedResources.currentOrderPage -= 1;
      this.currentOrderPage -= 1;
      this.refreshDisplay();
    }
  }

  goToNextPage() {
    if (this.currentOrderPage == this.numberOfOrderPages) {
      this.goToFirstPage()
    } else {
      SharedResources.currentOrderPage += 1;
      this.currentOrderPage += 1;
      this.refreshDisplay();
    }
  }

  goToLastPage() {
    SharedResources.currentOrderPage = this.numberOfOrderPages;
    this.currentOrderPage = this.numberOfOrderPages;
    this.refreshDisplay();
  }

  openDatePicker(modalDate : TemplateRef<any>) {
    this.modalService.open(modalDate, {ariaLabelledBy: 'modal-basic-title'}).result.then(
      (result) => {
      },
      (reason) => {
      });
  }

  applyDateFilter(modalDate:any) {

    this.currentOrderDateStart = this.intervalReceptie.value.start;
    this.currentOrderDateEnd = this.intervalReceptie.value.end;
    SharedResources.currentOrderDateStart = this.intervalReceptie.value.start;
    SharedResources.currentOrderDateEnd = this.intervalReceptie.value.end;
    modalDate.close();
    this.refreshDisplay();
  }

  openStateFilter(modalState: TemplateRef<any>) {
    this.modalService.open(modalState, {ariaLabelledBy: 'modal-basic-title'}).result.then(
      (result) => {
      },
      (reason) => {
      });
  }

  applyStateFilter(modalState: any) {
    this.currentOrderStates = '';
    for (let stare of this.stari.value) {
      this.currentOrderStates += stare + ",";
    }

    if (this.currentOrderStates.length > 0) {
      this.currentOrderStates = this.currentOrderStates.slice(0, this.currentOrderStates.length - 1);
    }
    SharedResources.currentOrderStates = this.currentOrderStates;
    modalState.close();
    this.refreshDisplay();
  }

  onChangeState(event: any, order : Orders) {
    if (order.Stare.toUpperCase() != event.target.value.toUpperCase()) {
      if (confirm(`Sunteți sigur(ă) că vreți să schimbați starea comenzii cu PO-ul ${order.PO} și numărul de factură ${order.NumarFactura} în ${event.target.value}?`)) {
        order.Stare = event.target.value;
        SharedResources._isLoadingBS.next(true);
        this.http.put<any>(`${APIHelper.APIUrl}order`,
          order,
          {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
              "Authorization": `Bearer ${localStorage.getItem('token')}`
            })
          }).subscribe(
          (response: any) => {
            alert("Starea comenzii modificată cu succes!");
            SharedResources._isLoadingBS.next(false);
            this.refreshDisplay()
          }, (error: any) => {
            alert(error.error);
            SharedResources._isLoadingBS.next(false);
            this.refreshDisplay()
          });
      }
    }
  }

  processOrder(order: Orders) {
    SharedResources.currentProcessedOrder = order;
    SharedResources.currentScreen = 'processOrder';
    SharedResources._currentScreenBS.next('processOrder');
  }
}
